// extracted by mini-css-extract-plugin
module.exports = {"specializationRequirement":"WeaponSelection_specializationRequirement__2FYsl","container":"WeaponSelection_container__AW5_O"};